import { createTheme } from '@mui/material';

// 1:1 aus warenwirtschaft-frontend/src/App.js übernommen, damit das Portal
// optisch zum Hauptprodukt passt.
export function createAppTheme(darkMode) {
  return createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: { main: '#F5C400', light: '#FFD740', dark: '#C49B00', contrastText: '#1A1A1A' },
      secondary: { main: '#F5C400', light: '#FFD740', dark: '#C49B00', contrastText: '#1A1A1A' },
      background: darkMode
        ? { default: '#111111', paper: '#1A1A1A' }
        : { default: '#F0F4F8', paper: '#FFFFFF' },
      success: { main: '#10B981' },
      warning: { main: '#F5C400' },
      error: { main: '#EF4444' },
      text: darkMode
        ? { primary: '#F1F5F9', secondary: '#9A9A9A' }
        : { primary: '#1E293B', secondary: '#6B7280' },
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily: "'Inter', sans-serif",
      h5: { fontWeight: 700 },
      h6: { fontWeight: 600 },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: 16, backgroundImage: 'none', border: darkMode ? '1px solid rgba(245,196,0,0.15)' : '1px solid rgba(0,0,0,0.08)' },
        },
      },
      MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 10, textTransform: 'none', fontWeight: 600 },
          containedPrimary: { backgroundColor: '#F5C400', color: '#1A1A1A', '&:hover': { backgroundColor: '#FFD740' } },
          // Gelbe Schrift auf Weiss ist nicht lesbar: Umriss-Knoepfe bekommen
          // die Textfarbe, das Gelb bleibt im Rahmen.
          outlinedPrimary: {
            color: darkMode ? '#F1F5F9' : '#1E293B',
            borderColor: darkMode ? 'rgba(245,196,0,0.55)' : '#D9AE00',
            '&:hover': { borderColor: '#F5C400', backgroundColor: 'rgba(245,196,0,0.12)' },
          },
          textPrimary: { color: darkMode ? '#F5C400' : '#7A6000' },
        },
      },
      MuiTextField: { defaultProps: { variant: 'outlined', size: 'small' } },
      MuiLink: { styleOverrides: { root: { color: darkMode ? '#F5C400' : '#7A6000', textDecorationColor: 'rgba(196,155,0,0.5)' } } },
      MuiChip: {
        styleOverrides: {
          root: { borderRadius: 8, fontWeight: 500 },
          colorWarning: { backgroundColor: '#F5C400', color: '#1A1A1A' },
        },
      },
      MuiDialog: { defaultProps: { disableEnforceFocus: true } },
      MuiTableHead: {
        styleOverrides: {
          root: {
            '& .MuiTableCell-head': {
              backgroundColor: darkMode ? '#1A1A1A' : '#F0F4F8',
              fontWeight: 700,
              color: darkMode ? '#9A9A9A' : '#6B7280',
              fontSize: '0.75rem',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            },
          },
        },
      },
      MuiTableRow: {
        styleOverrides: { root: { '&:hover': { backgroundColor: 'rgba(245,196,0,0.05)' } } },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: darkMode ? '#141414' : '#F8FAFC',
            borderRight: darkMode ? '1px solid rgba(245,196,0,0.15)' : '1px solid rgba(0,0,0,0.1)',
          },
        },
      },
    },
  });
}
